import YourInvitesModal from './YourInvitesModal';

export default YourInvitesModal;
